import { render, staticRenderFns } from "./setting-scheduling.vue?vue&type=template&id=0cc56a1f&scoped=true&"
import script from "./setting-scheduling.vue?vue&type=script&lang=js&"
export * from "./setting-scheduling.vue?vue&type=script&lang=js&"
import style0 from "./setting-scheduling.vue?vue&type=style&index=0&id=0cc56a1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc56a1f",
  null
  
)

export default component.exports